import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { Accordion, AccordionPanel, Glyphicon } from 'reaxl';

/**
 *  Sitemap generates a sitemap in the form of an accordion for mobile devices and columned link sections for larger viewports
 *
 */
function NonstaticSitemap(_ref) {
  let {
    collapsed = false,
    data = [],
    ...rest
  } = _ref;
  const colNumber = Math.round(12 / data.length);
  const getColumn = column => [].concat(column);
  const renderSitemapItem = (_ref2, index) => {
    let {
      text,
      pagetype,
      glyph,
      img,
      ...itemRest
    } = _ref2;
    return /*#__PURE__*/_jsx("li", {}, `${itemRest.href}/${pagetype}-${index}`, /*#__PURE__*/React.createElement("a", itemRest, text, glyph && /*#__PURE__*/_jsx(Glyphicon, {
      className: "margin-left-2",
      glyph: glyph
    })));
  };
  const renderSitemapAccordionPanel = column => getColumn(column).map(_ref3 => {
    let {
      title,
      items
    } = _ref3;
    return /*#__PURE__*/_jsx(AccordionPanel, {
      eventKey: title,
      title: title
    }, title, /*#__PURE__*/_jsx("ul", {
      className: "list-unstyled text-inverse"
    }, void 0, items.map(renderSitemapItem)));
  });
  const renderSitemapSection = section => /*#__PURE__*/_jsx("div", {}, section.title, /*#__PURE__*/_jsx("div", {
    className: "text-bold"
  }, void 0, section.title), /*#__PURE__*/_jsx("ul", {
    className: "list-unstyled text-inverse"
  }, void 0, section.items.map(renderSitemapItem)));
  const renderSitemapColumn = (column, index) => /*#__PURE__*/_jsx("div", {
    className: `col col-sm-${colNumber} text-inverse`
  }, index, getColumn(column).map(renderSitemapSection));
  const renderAccordion = () => /*#__PURE__*/_jsx(Accordion, {
    bsStyle: "filters"
  }, void 0, data.map(renderSitemapAccordionPanel));
  const renderColumns = () => data.map(renderSitemapColumn);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "sitemap",
    className: "row"
  }, rest), collapsed ? renderAccordion() : renderColumns());
}

// propTypes is deprecated by react

export default NonstaticSitemap;